import { useQuery } from 'react-query';

//APP
import { api } from '../../api';
import { localConfig } from '../../../Configs/localConfig';
import { errorAlert } from '../../../utils/alert';
import { useAccess } from '../../../context/useAccess';
import secureLocalStorage from 'react-secure-storage';

//=================================================================================>
// BUSCAR LISTA DE PROPRIEDADES E SEUS TALHÕES
//<=================================================================================

//TYPES
export type Item__EquipeCliente = {
    cod: number | null,
    cod_func: number | null,
    cod_conta: number | null,
    cod_cliente: number | null,
    status: number | null,
    acessa_sistema: number | null,
    cod_perfil_conta: number | null,
    cod_perfil_cliente: number | null,
    cod_perfil_cliente_geral: number | null,
    cod_consultor: number | null,
    acesso_cliente: number | null,
    responsavel_fertilidade: boolean,
    usuario_nome: string | null,
    conta_nome: string | null,
    cliente_nome: string | null,
    email: string | null,
    cliente_logo: string | null,
    conta_logo: string | null,
    conta_logo_url: string | null,
}

//INTERFACE
export interface EquipeCliente {
    itens: Item__EquipeCliente[]
}

export const useGetEquipeCliente = () => {

    let { conta, codCliente } = localConfig();
    const { consultoria } = useAccess();

    const codConsultoria = consultoria?.cod;
    const isConsultoria = secureLocalStorage.getItem('tipo-acesso') === 'conta';


    const queryKey: any = isConsultoria ? ['equipe_cliente', conta, codCliente, consultoria?.cod] : ['equipe_cliente', 'logado_como_cliente', conta, codCliente];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<EquipeCliente, Error>(queryKey, async () => {


        const requisicoes: Promise<any>[] = [
            api.get(`/equipe?codConta=${conta}&codCliente=${codCliente}&pagination=-1`)
        ];

        if (isConsultoria) {
            requisicoes.push(
                api.get(`/equipe?codConta=${conta}&codConsultoria=${codConsultoria}&pagination=-1`)
            );
        }

        return Promise.all(requisicoes)
            .then((resultados): any => {
                const resCliente = resultados[0];
                const resConsultoria = resultados.length > 1 ? resultados[1] : null;

                const itensCliente = resCliente?.data?.itens || [];
                const itensConsultoria = resConsultoria?.data?.itens || [];

                itensConsultoria.forEach((item: Item__EquipeCliente) => {
                    if (item.usuario_nome) {
                        item.usuario_nome = `${item.usuario_nome} (Consultoria)`;
                    }
                });

                // Remove duplicates based on 'cod_func'
                const uniqueItens = new Map();
                [...itensCliente, ...itensConsultoria].forEach(item => {
                    if (item && item.cod_func) {
                        uniqueItens.set(item.cod_func, item);
                    }
                });

                return { itens: Array.from(uniqueItens.values()) };
            })
            .catch((error) => {
                console.log("error: ", error)
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de membros da equipe!');
            })
    },
        {
            enabled: !!conta && !!codCliente,
            refetchOnWindowFocus: false,
            staleTime: 200000
        }
    );

    return {
        data_equipe_cliente: data?.itens,
        carregando_equipe_cliente: isFetching,
        refetch_equipe_cliente: refetch,
        isFetched: isFetchedAfterMount,
        isError: isError
    };
};